import React from 'react';

function Devider() {
  return (
    <div className='content'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='progress'>
              <div
                className='progress-bar'
                role='progressbar'
                aria-valuenow='30'
                aria-valuemin='0'
                aria-valuemax='100'
                style={{ width: '30%' }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Devider;
